import React from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import WebLayout from "../components/WebLayout";
import PostList from "../components/PostList";

const GET_EVENTS = gql`
  query GetEvents {
    articles(category: EVENT) {
      id
      title
      source
      picture {
        filename
        mimetype
        encoding
        location
      }
      description
      content
      createdAt
    }
  }
`;

export default function Event() {
  const { data } = useQuery(GET_EVENTS);
  return (
    <WebLayout>
      {data && <PostList data={data.articles} />}
    </WebLayout>
  );
}
